(() => {
  function initialize(root) {
    if (!root || root.dataset.yagakuLpReady === "true") return;
    root.dataset.yagakuLpReady = "true";

    const revealTargets = Array.from(root.querySelectorAll("[data-reveal]"));
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reducedMotion || !("IntersectionObserver" in window)) {
      revealTargets.forEach((target) => target.setAttribute("data-visible", "true"));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute("data-visible", "true");
            revealObserver.unobserve(entry.target);
          });
        },
        { root: null, rootMargin: "-80% 0px -20%", threshold: 0 },
      );
      revealTargets.forEach((target) => revealObserver.observe(target));
    }

    const floatingPurchase = root.querySelector("[data-floating-purchase]");
    const purchaseSection = root.querySelector("[data-purchase-section]");
    if (floatingPurchase && purchaseSection && "IntersectionObserver" in window) {
      const purchaseObserver = new IntersectionObserver(
        ([entry]) => floatingPurchase.classList.toggle("is-hidden", entry.isIntersecting),
        { threshold: 0.08 },
      );
      purchaseObserver.observe(purchaseSection);
    }
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll("[data-yagaku-lp]").forEach(initialize);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
